import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AdminViewOnlyClass;
function AdminViewOnly() {
  if (AdminViewOnlyClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof AdminViewOnly()))
          return false;
        other instanceof AdminViewOnly() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.services.data.AdminViewOnly(' + ')';
      }
    }
    initMetadataForClass($, 'AdminViewOnly');
    AdminViewOnlyClass = $;
  }
  return AdminViewOnlyClass;
}
var ReferencesClass;
function References() {
  if (ReferencesClass === VOID) {
    class $ {
      constructor(references, reverseName) {
        reverseName = reverseName === VOID ? '' : reverseName;
        this.references_1 = references;
        this.reverseName_1 = reverseName;
      }
      equals(other) {
        if (!(other instanceof References()))
          return false;
        var tmp0_other_with_cast = other instanceof References() ? other : THROW_CCE();
        if (!this.references_1.equals(tmp0_other_with_cast.references_1))
          return false;
        if (!(this.reverseName_1 === tmp0_other_with_cast.reverseName_1))
          return false;
        return true;
      }
      hashCode() {
        var result = imul(getStringHashCode('references'), 127) ^ this.references_1.hashCode();
        result = result + (imul(getStringHashCode('reverseName'), 127) ^ getStringHashCode(this.reverseName_1)) | 0;
        return result;
      }
      toString() {
        return '@com.lightningkite.services.data.References(' + 'references=' + toString(this.references_1) + ', ' + 'reverseName=' + this.reverseName_1 + ')';
      }
    }
    initMetadataForClass($, 'References');
    ReferencesClass = $;
  }
  return ReferencesClass;
}
var AdminTitleFieldsClass;
function AdminTitleFields() {
  if (AdminTitleFieldsClass === VOID) {
    class $ {
      constructor(fields) {
        this.fields_1 = fields;
      }
      equals(other) {
        if (!(other instanceof AdminTitleFields()))
          return false;
        var tmp0_other_with_cast = other instanceof AdminTitleFields() ? other : THROW_CCE();
        if (!contentEquals(this.fields_1, tmp0_other_with_cast.fields_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('fields'), 127) ^ hashCode(this.fields_1);
      }
      toString() {
        return '@com.lightningkite.services.data.AdminTitleFields(' + 'fields=' + toString(this.fields_1) + ')';
      }
    }
    initMetadataForClass($, 'AdminTitleFields');
    AdminTitleFieldsClass = $;
  }
  return AdminTitleFieldsClass;
}
var AdminTableColumnsClass;
function AdminTableColumns() {
  if (AdminTableColumnsClass === VOID) {
    class $ {
      constructor(fields) {
        this.fields_1 = fields;
      }
      equals(other) {
        if (!(other instanceof AdminTableColumns()))
          return false;
        var tmp0_other_with_cast = other instanceof AdminTableColumns() ? other : THROW_CCE();
        if (!contentEquals(this.fields_1, tmp0_other_with_cast.fields_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('fields'), 127) ^ hashCode(this.fields_1);
      }
      toString() {
        return '@com.lightningkite.services.data.AdminTableColumns(' + 'fields=' + toString(this.fields_1) + ')';
      }
    }
    initMetadataForClass($, 'AdminTableColumns');
    AdminTableColumnsClass = $;
  }
  return AdminTableColumnsClass;
}
var NaturalSortClass;
function NaturalSort() {
  if (NaturalSortClass === VOID) {
    class $ {
      constructor(fields) {
        this.fields_1 = fields;
      }
      equals(other) {
        if (!(other instanceof NaturalSort()))
          return false;
        var tmp0_other_with_cast = other instanceof NaturalSort() ? other : THROW_CCE();
        if (!contentEquals(this.fields_1, tmp0_other_with_cast.fields_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('fields'), 127) ^ hashCode(this.fields_1);
      }
      toString() {
        return '@com.lightningkite.services.data.NaturalSort(' + 'fields=' + toString(this.fields_1) + ')';
      }
    }
    initMetadataForClass($, 'NaturalSort');
    NaturalSortClass = $;
  }
  return NaturalSortClass;
}
var IndexClass;
function Index() {
  if (IndexClass === VOID) {
    class $ {
      constructor(unique, name) {
        unique = unique === VOID ? IndexUniqueness_NotUnique_getInstance() : unique;
        name = name === VOID ? '' : name;
        this.unique_1 = unique;
        this.name_1 = name;
      }
      equals(other) {
        if (!(other instanceof Index()))
          return false;
        var tmp0_other_with_cast = other instanceof Index() ? other : THROW_CCE();
        if (!this.unique_1.equals(tmp0_other_with_cast.unique_1))
          return false;
        if (!(this.name_1 === tmp0_other_with_cast.name_1))
          return false;
        return true;
      }
      hashCode() {
        var result = imul(getStringHashCode('unique'), 127) ^ this.unique_1.hashCode();
        result = result + (imul(getStringHashCode('name'), 127) ^ getStringHashCode(this.name_1)) | 0;
        return result;
      }
      toString() {
        return '@com.lightningkite.services.data.Index(' + 'unique=' + this.unique_1.toString() + ', ' + 'name=' + this.name_1 + ')';
      }
    }
    initMetadataForClass($, 'Index');
    IndexClass = $;
  }
  return IndexClass;
}
var DenormalizedClass;
function Denormalized() {
  if (DenormalizedClass === VOID) {
    class $ {
      constructor(calculationId) {
        calculationId = calculationId === VOID ? '' : calculationId;
        this.calculationId_1 = calculationId;
      }
      equals(other) {
        if (!(other instanceof Denormalized()))
          return false;
        var tmp0_other_with_cast = other instanceof Denormalized() ? other : THROW_CCE();
        if (!(this.calculationId_1 === tmp0_other_with_cast.calculationId_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('calculationId'), 127) ^ getStringHashCode(this.calculationId_1);
      }
      toString() {
        return '@com.lightningkite.services.data.Denormalized(' + 'calculationId=' + this.calculationId_1 + ')';
      }
    }
    initMetadataForClass($, 'Denormalized');
    DenormalizedClass = $;
  }
  return DenormalizedClass;
}
var DescriptionClass;
function Description() {
  if (DescriptionClass === VOID) {
    class $ {
      constructor(text) {
        this.text_1 = text;
      }
      equals(other) {
        if (!(other instanceof Description()))
          return false;
        var tmp0_other_with_cast = other instanceof Description() ? other : THROW_CCE();
        if (!(this.text_1 === tmp0_other_with_cast.text_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('text'), 127) ^ getStringHashCode(this.text_1);
      }
      toString() {
        return '@com.lightningkite.services.data.Description(' + 'text=' + this.text_1 + ')';
      }
    }
    initMetadataForClass($, 'Description');
    DescriptionClass = $;
  }
  return DescriptionClass;
}
var GroupClass;
function Group() {
  if (GroupClass === VOID) {
    class $ {
      constructor(name) {
        this.name_1 = name;
      }
      equals(other) {
        if (!(other instanceof Group()))
          return false;
        var tmp0_other_with_cast = other instanceof Group() ? other : THROW_CCE();
        if (!(this.name_1 === tmp0_other_with_cast.name_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('name'), 127) ^ getStringHashCode(this.name_1);
      }
      toString() {
        return '@com.lightningkite.services.data.Group(' + 'name=' + this.name_1 + ')';
      }
    }
    initMetadataForClass($, 'Group');
    GroupClass = $;
  }
  return GroupClass;
}
var MultilineClass;
function Multiline() {
  if (MultilineClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof Multiline()))
          return false;
        other instanceof Multiline() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.services.data.Multiline(' + ')';
      }
    }
    initMetadataForClass($, 'Multiline');
    MultilineClass = $;
  }
  return MultilineClass;
}
var IndexSetClass;
function IndexSet() {
  if (IndexSetClass === VOID) {
    class $ {
      constructor(fields, unique, name) {
        unique = unique === VOID ? IndexUniqueness_NotUnique_getInstance() : unique;
        name = name === VOID ? '' : name;
        this.fields_1 = fields;
        this.unique_1 = unique;
        this.name_1 = name;
      }
      equals(other) {
        if (!(other instanceof IndexSet()))
          return false;
        var tmp0_other_with_cast = other instanceof IndexSet() ? other : THROW_CCE();
        if (!contentEquals(this.fields_1, tmp0_other_with_cast.fields_1))
          return false;
        if (!this.unique_1.equals(tmp0_other_with_cast.unique_1))
          return false;
        if (!(this.name_1 === tmp0_other_with_cast.name_1))
          return false;
        return true;
      }
      hashCode() {
        var result = imul(getStringHashCode('fields'), 127) ^ hashCode(this.fields_1);
        result = result + (imul(getStringHashCode('unique'), 127) ^ this.unique_1.hashCode()) | 0;
        result = result + (imul(getStringHashCode('name'), 127) ^ getStringHashCode(this.name_1)) | 0;
        return result;
      }
      toString() {
        return '@com.lightningkite.services.data.IndexSet(' + 'fields=' + toString(this.fields_1) + ', ' + 'unique=' + this.unique_1.toString() + ', ' + 'name=' + this.name_1 + ')';
      }
    }
    initMetadataForClass($, 'IndexSet');
    IndexSetClass = $;
  }
  return IndexSetClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  IndexUniqueness_NotUnique_instance = new (IndexUniqueness())('NotUnique', 0, false);
  IndexUniqueness_Unique_instance = new (IndexUniqueness())('Unique', 1, true);
  IndexUniqueness_UniqueNullSparse_instance = new (IndexUniqueness())('UniqueNullSparse', 2, true);
}
var IndexUniqueness_NotUnique_instance;
var IndexUniqueness_Unique_instance;
var IndexUniqueness_UniqueNullSparse_instance;
var IndexUniquenessClass;
function IndexUniqueness() {
  if (IndexUniquenessClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, isUnique) {
        super(name, ordinal);
        this.isUnique_1 = isUnique;
      }
    }
    initMetadataForClass($, 'IndexUniqueness');
    IndexUniquenessClass = $;
  }
  return IndexUniquenessClass;
}
var MaxLengthClass;
function MaxLength() {
  if (MaxLengthClass === VOID) {
    class $ {
      constructor(size, average) {
        average = average === VOID ? -1 : average;
        this.size_1 = size;
        this.average_1 = average;
      }
      equals(other) {
        if (!(other instanceof MaxLength()))
          return false;
        var tmp0_other_with_cast = other instanceof MaxLength() ? other : THROW_CCE();
        if (!(this.size_1 === tmp0_other_with_cast.size_1))
          return false;
        if (!(this.average_1 === tmp0_other_with_cast.average_1))
          return false;
        return true;
      }
      hashCode() {
        var result = imul(getStringHashCode('size'), 127) ^ this.size_1;
        result = result + (imul(getStringHashCode('average'), 127) ^ this.average_1) | 0;
        return result;
      }
      toString() {
        return '@com.lightningkite.services.data.MaxLength(' + 'size=' + this.size_1 + ', ' + 'average=' + this.average_1 + ')';
      }
    }
    initMetadataForClass($, 'MaxLength');
    MaxLengthClass = $;
  }
  return MaxLengthClass;
}
var DisplayNameClass;
function DisplayName() {
  if (DisplayNameClass === VOID) {
    class $ {
      constructor(text) {
        this.text_1 = text;
      }
      equals(other) {
        if (!(other instanceof DisplayName()))
          return false;
        var tmp0_other_with_cast = other instanceof DisplayName() ? other : THROW_CCE();
        if (!(this.text_1 === tmp0_other_with_cast.text_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('text'), 127) ^ getStringHashCode(this.text_1);
      }
      toString() {
        return '@com.lightningkite.services.data.DisplayName(' + 'text=' + this.text_1 + ')';
      }
    }
    initMetadataForClass($, 'DisplayName');
    DisplayNameClass = $;
  }
  return DisplayNameClass;
}
var DoesNotNeedLabelClass;
function DoesNotNeedLabel() {
  if (DoesNotNeedLabelClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof DoesNotNeedLabel()))
          return false;
        other instanceof DoesNotNeedLabel() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.services.data.DoesNotNeedLabel(' + ')';
      }
    }
    initMetadataForClass($, 'DoesNotNeedLabel');
    DoesNotNeedLabelClass = $;
  }
  return DoesNotNeedLabelClass;
}
var TextIndexClass;
function TextIndex() {
  if (TextIndexClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TextIndex');
    TextIndexClass = $;
  }
  return TextIndexClass;
}
function IndexUniqueness_NotUnique_getInstance() {
  static_init();
  return IndexUniqueness_NotUnique_instance;
}
function IndexUniqueness_Unique_getInstance() {
  static_init();
  return IndexUniqueness_Unique_instance;
}
function IndexUniqueness_UniqueNullSparse_getInstance() {
  static_init();
  return IndexUniqueness_UniqueNullSparse_instance;
}
//region block: exports
export {
  AdminTableColumns as AdminTableColumns127mx0x3shj3w,
  AdminTitleFields as AdminTitleFields1r7jr8w0z0gjc,
  AdminViewOnly as AdminViewOnlyyhkyako4fc99,
  Denormalized as Denormalized13y861o5nekmb,
  Description as Description1f0zycfwk0zld,
  DisplayName as DisplayName1fbm5f1dqkty3,
  DoesNotNeedLabel as DoesNotNeedLabellvuub2wyj63e,
  Group as Group209swmzf2sz2h,
  IndexSet as IndexSetppgakdbfpe00,
  Index as Index2tzg8vllut89f,
  MaxLength as MaxLength2eo8ysfurfau1,
  Multiline as Multilinevduzy7shc6h7,
  NaturalSort as NaturalSort21fbc8xpuy7g0,
  References as References31yy1vpluik8j,
  TextIndex as TextIndex284xshohgiyzv,
  IndexUniqueness_UniqueNullSparse_getInstance as IndexUniqueness_UniqueNullSparse_getInstance15k4mz8ry6mov,
  IndexUniqueness_Unique_getInstance as IndexUniqueness_Unique_getInstance3k1wv494ui8l1,
};
//endregion

//# sourceMappingURL=Annotations.mjs.map
